import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import { useDispatch, useSelector } from "react-redux";
import { sortByName } from "../../../../../utils/sortByName";

export default function ApplyNakalaKafala({
  data,
  setPopUp,
  onSuccess,
  setTrigger,
  trigger,
}) {
  console.log("props data to be printed in the console", data);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    // console.log(selectedFiles);
    setFile(selectedFiles);
  };
  const [Data, setFormData] = useState({
    application_date: "",
    new_visa_provider: "",
    change_fee: "",
    borne_by: "",
  });
  const [visaProvider, SetVisaProvider] = useState([]);

  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  console.log("Data to be printed in the console", data);
  console.log("Data to be seen here in the console", data);
  useEffect(() => {
    getVisaProvider();
  }, []);

  const getVisaProvider = async () => {
    try {
      const result = await nodeinstance.get(`/sadaad/visa-providers/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = result?.data?.data;
      console.log("visa provider data to be seen in console", data);
      SetVisaProvider(sortByName(data));
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  const token = localStorage.getItem("nodeToken");
  const [segement, setSegment] = useState();

  const submitHandler = async (e) => {
    console.log("Log to be seen here in browser", selectVisaProvider);
    e.preventDefault();
    setLoading(true);
  
    if (data.visa_provider === Data.new_visa_provider) {
      dispatch(
        setAppError({
          msg: "Same visa provider cannot be selected",
        })
      );
      setLoading(false);
      return;
    }
  
    const filterData = visaProvider.filter(
      (data) => data.name === Data.new_visa_provider
    );
    console.log("filterData.........", filterData);
  
    let segment = false;
    if (filterData.length > 0) {
      segment = filterData[0].sub_segment === (data.new_visa_segment || data.Company_segment);
    }
  
    const formData = new FormData();
  
    // Append files
    if (file && typeof file === "object") {
      Object.keys(file).forEach((key) => {
        const fileData = file[key];
        if (fileData instanceof File) {
          formData.append("file", fileData);
        }
      });
    }
  
    // Append form data fields
    formData.append("employee_id", data.employee_id);
    formData.append("application_date", Data.application_date);
    formData.append("new_visa_provider", Data.new_visa_provider);
    formData.append("change_fee", Data.change_fee);
    formData.append("borne_by", Data.borne_by);
    formData.append("sub_segment", segment ? "Same" : "Changing");
    formData.append("new_visa_segment", filterData[0]?.sub_segment || "");
    formData.append("new_visa_provider_id", Data.visa_provider_id);
  
    try {
      const res = await nodeinstance.post("/nakal-kafala/UpdateNakalKafala", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (res.status === 200) {
        setPopUp(false);
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        onSuccess();
        setTrigger((prev) => !prev); // Prevent infinite loops
      } else {
        dispatch(
          setAppError({
            msg: res?.error || "An error occurred.",
            color: "error",
          })
        );
      }
    } catch (error) {
      console.error("Error occurred:", error.response || error);
      dispatch(
        setAppError({
          msg: error.response?.data?.message || error.message,
        })
      );
    } finally {
      setLoading(false);
    }
  };
  

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };
  console.log("log to be printed in the console for reference");
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">Request Nakal Kafala</h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={submitHandler}
            className="w-full flex flex-col my-4 gap-3"
          >
            <div className="flex flex-col gap-1">
              <label className="text-sm">Application Date</label>
              <input
                type="date"
                onKeyDown={handleKeyDown}
                id="field2"
                className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
                onChange={(e) =>
                  setFormData({ ...Data, application_date: e.target.value })
                }
                name="application_date"
                required
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">New Visa Provider</label>
              <select
                className="border-[1px] uppercase  border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={selectVisaProvider}
                onChange={(e) => {
                  const selectedName = e.target.value;
                  setSelectVisaProvider(selectedName);

                  // Find the selected visa provider object
                  const selectedProvider = visaProvider.find(
                    (provider) => provider.name === selectedName
                  );

                  setFormData({
                    ...Data,
                    new_visa_provider: selectedName,
                    visa_provider_id: selectedProvider?.id || null, // Store the id
                  });
                }}
                required
              >
                <option value=""> Visa Provider</option>
                {visaProvider.map((filetype) => (
                  <option key={filetype?.id} value={filetype?.name}>
                    {filetype?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm">Renewal Fee</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                onChange={(e) =>
                  setFormData({ ...Data, change_fee: e.target.value })
                }
                name="change_fee"
                required
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">
                Upload Employee Muqeem Documents
              </label>
              <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={handleFileChange}
                required
                accept="application/.pdf"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Borne By</label>
              <div className="flex items-center space-x-8">
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="SLA"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">SLA</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Client"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Client</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Employee"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Employee</span>
                </label>
              </div>
            </div>

            <div className="flex  gap-3 mx-auto my-3 w-full px-5">
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
